export default __webpack_public_path__ + "static/media/IV-2023.2cfd4378.pdf";